import React from "react";

const WhatsAppIcon = () => {
  return (
    <div
      style={{
        position: "fixed",
        bottom: "60px",
        right: "2rem",
        cursor: "pointer",
        height: "60px",
        width: "60px",
      }}
    >
      <a href="https://wa.me/917567096999/" target="_blank">
        <img
          src="http://www.websiteimages.careerline.in/uploads/WhatsAppIcon.png"
          height="60"
          alt="WhatsApp"
        />
      </a>
    </div>
  );
};

export default WhatsAppIcon;
